import React from 'react';
import { Box, Typography } from '@mui/material';
import { getEmbeddableUrl } from '../utils/lmsEmbedUrl';

const LmsEmbedFrame = ({ url }) => {
  const embed = getEmbeddableUrl(url);
  if (!embed) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          This link cannot be shown here. Use a YouTube video link or a full website address starting with https://.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="iframe"
      src={embed.src}
      title={embed.kind === 'youtube' ? 'YouTube video' : 'Website'}
      sx={{
        width: '100%',
        height: '100%',
        minHeight: '600px',
        border: 'none',
        backgroundColor: embed.kind === 'youtube' ? 'black' : '#fff',
      }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
    />
  );
};

export default LmsEmbedFrame;
